import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppFacade } from '@app/app.facade';

@Pipe({
  name: 'countryCodeByAirport',
  standalone: false
})
export class CountryCodeByAirportPipe implements PipeTransform {

  constructor(private readonly facade: AppFacade) { }

  transform(code: string): Observable<string> {
    return this.facade.airports$
      .pipe(
        map(airlines => airlines?.find(x => x?.code === code)?.country)
      );
  }
}
